import React from "react";

type ErrorHintProps = {
  children: React.ReactNode;
  dataLoc?: string;
};

export const ErrorHint: React.FC<ErrorHintProps> = ({
  children,
  dataLoc = "error-hint",
}) => {
  return (
    <p
      className="mt-1 mb-2 font-inter-normal-12px text-red-600"
      data-loc={dataLoc}
    >
      {children}
    </p>
  );
};
